import { useEffect, useState } from "react"
import { useVideoInfiniteQuery } from "@/service/api/video"
import type { ListRequest } from "@/shared/types/commonResponse"
import ListHeader from "@/components/custom/ListHeader"
import VideoItem from "./VideoItem"
import { STAR_ID } from "@/shared/constants/star"
import { InfiniteScrollTrigger } from "@/components/etc/InfiniteScrollTrigger"

const VideoList = () => {
  const [videoList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 1000,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const {
    data: videoListData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useVideoInfiniteQuery(videoList)

  const items = videoListData?.pages.flatMap((page) => page.content) ?? []

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div>
      <ListHeader title="Video" />

      <div className="overflow-y-auto px-4 pt-16">
        <div className="flex flex-col">
          {items.map((item, i) => (
            <VideoItem
              key={`${item.id}-${i}`}
              id={item.id}
              title={item.title}
              image={item.thumbImageUrl}
              date={item.regDt}
              main
              videoList={items}
            />
          ))}

          <InfiniteScrollTrigger
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            onLoadMore={fetchNextPage}
          />
        </div>
      </div>
    </div>
  )
}

export default VideoList
